import { render, staticRenderFns } from "./product_tab4.vue?vue&type=template&id=6d9f9e80&"
import script from "./product_tab4.vue?vue&type=script&lang=js&"
export * from "./product_tab4.vue?vue&type=script&lang=js&"
import style0 from "./product_tab4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports